// @flow

import * as React from 'react';
import moment from 'moment';
import { ISO_DAYS } from 'common/domain/DayOfWeek';
import SpecificDateRangePicker, { DateRangePickerProps } from './SpecificDateRangePicker';

const ISO_WEEK_DAYS = [
  ISO_DAYS.MONDAY,
  ISO_DAYS.TUESDAY,
  ISO_DAYS.WEDNESDAY,
  ISO_DAYS.THURSDAY,
  ISO_DAYS.FRIDAY,
];

export default function WeekPicker(props: DateRangePickerProps) {
  return (
    <SpecificDateRangePicker
      {...props}
      disabledDates={getDisabledDates(props)}
      getRange={findWeekFor}
      selectableISODays={ISO_WEEK_DAYS}
    />
  );
}

function getDisabledDates({ minDate, maxDate }: DateRangePickerProps) {
  const disabled = {};

  minDate && (disabled.before = minDate.clone().isoWeekday(6).toDate());
  maxDate && (disabled.after = maxDate.clone().isoWeekday(0).toDate());

  return disabled;
}

function findWeekFor(day: Date) {
  const date = moment(day);

  if (date.isoWeekday() >= 6) {
    return {
      from: undefined,
      to: undefined,
    };
  }

  return {
    from: date.clone().isoWeekday(1).toDate(),
    to: date.clone().isoWeekday(5).toDate(),
  };
}




// WEBPACK FOOTER //
// ./src/common/components/ui/datePicker/WeekPicker.js